import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import CtaButton from 'components/cta-button'

import styles from '../styles.module.scss'

const SimpleCTAComponent = (props) => {
  const { className, href, customCTA, onClick, variations, variation } = props
  return (
    <CtaButton
      data-testid="simple-cta"
      href={href}
      className={cx(className, styles.ctaMobile, {
        [styles.truncated]: customCTA,
      })}
      onClick={onClick}
      target="_blank"
    >
      {customCTA || variations[variation]}
    </CtaButton>
  )
}

SimpleCTAComponent.propTypes = {
  className: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  customCTA: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  variations: PropTypes.object.isRequired,
  variation: PropTypes.string.isRequired,
}

export default SimpleCTAComponent
